import React, { useEffect, useState } from "react";
import {
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";
import { Delete } from "@mui/icons-material";
import { baseUrl } from "../../config/axios";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
  rounded: 2,
};

const Slider = () => {
  const [currentPage, setCurrentPage] = useState(null);
  const [totalPage, setTotalPage] = useState(null);
  const storeId = localStorage.getItem("store_id");
  const [data, setData] = useState([]);
  const [open1, setOpen1] = React.useState(false);

  const [categoryData, setCategoryData] = useState([]);
  const [subCategoryData, setSubCategoryData] = useState([]);
  const [brandData, setBrandData] = useState([]);
  const [bannerData, setBannerData] = useState([]);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  // add product varient start
  const [categoryId, setCategoryId] = useState("");
  const [brandId, setBrandId] = useState("");
  const [subCategoryId, setSubCategoryId] = useState("");
  const [bannerName, setBannerName] = useState("");
  const [image, setImage] = useState("");
  const [offerTag, setOfferTag] = useState("");
  const [mainTitle, setMainTitle] = useState("");
  const [description, setDescription] = useState("");
  const [manual_link, setManualLink] = useState("");
  const [rowData, setRowData] = useState({});
  const [ids, setIds] = useState(null);
  const handleOpen1 = () => setOpen1(true);
  const handleClose1 = () => setOpen1(false);

  const mainCategoryList = () => {
    axios
      .post(
        `${baseUrl}api/admin/multivendor-show-main-category-list/`,
        {
          store_id: storeId,
        },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setCategoryData(response?.data?.main_category_data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };
  useEffect(() => {
    mainCategoryList();
  }, []);
  console.log(rowData?.category?.id, "llll");
  const subCategoryList = () => {
    const fd = new FormData();
    fd.append("main_category_id", categoryId || rowData?.category?.id);
    axios
      .post(
        `${baseUrl}api/admin/multivendor-show-sub-category-list-by-id/`,
        fd,
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setSubCategoryData(response?.data?.sub_cat_list);
      })
      .catch((error) => {
        console.log("error page", error.response);
        console.log(error);
      });
  };

  useEffect(() => {
    categoryId && subCategoryList();
    rowData?.category?.id !== undefined && subCategoryList();
  }, [categoryId, rowData]);

  const submitCategory = () => {
    const reqbody = new FormData();
    reqbody.append("banner_id", ids);
    reqbody.append("store_id", storeId);
    reqbody.append("category_id", categoryId || rowData?.category?.id);
    reqbody.append("brand_id", brandId || rowData?.brand?.id);
    reqbody.append("subcategory_id", subCategoryId || rowData?.subcategory?.id);
    reqbody.append("banner_image", image);
    reqbody.append(
      "banner_section_name",
      bannerName || rowData?.banner_section || ""
    );
    reqbody.append("offer_tag", offerTag);
    reqbody.append("main_title", mainTitle);
    reqbody.append("description", description);
    reqbody.append("manual_link", manual_link)

    ids === null
      ? axios
        .post(
          `${baseUrl}api/admin/multivendor-add-banner/`,
          reqbody,
          {
            headers: {
              Token: localStorage.getItem("Token"),
            },
          }
        )
        .then((response) => {
          console.log("success");
          toast.success(response.data.message);
          handleModalClose()
          handleClose1();
          bannerListShow();
        })
        .catch((error) => {
          console.log("", error);
        })
      : axios
        .post(
          `${baseUrl}api/admin/multivendor-update-banner/`,
          reqbody,
          {
            headers: {
              Token: localStorage.getItem("Token"),
              "Content-Type": "multipart/formdata",
            },
          }
        )
        .then((response) => {
          console.log("success");
          handleModalClose()
          toast.success(response.data.message);
          handleClose1();
          bannerListShow();
        })
        .catch((error) => {
          console.log("", error);
        });
  };

  const editFunctionality = (row) => {
    console.log("row Data==>", row);
    setRowData(row);
    setIds(row?.id);
    setMainTitle(row?.main_title);
    setDescription(row?.description);
    setOfferTag(row?.offer_tag);
    setManualLink(row?.manual_link)
    setCategoryId(row?.category?.id)
    setBrandId(row?.brand?.id)
    setSubCategoryId(row?.subcategory?.id)

  };

  const bannerListShow = () => {
    axios
      .post(
        `${baseUrl}api/admin/multivendor-banner-list/`,
        { store_id: storeId, page: page },

        {
          params: {
            search: search,
          },
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        console.log(response?.data?.vendor_wallet_transaction, "data");
        setData(response?.data?.vendor_wallet_transaction);
        setCurrentPage(response?.data?.current_page);
        setTotalPage(response?.data?.total_pages);
      })
      .catch((error) => {
        console.log("", error);
      });
  };

  useEffect(() => {
    bannerListShow();
  }, [page, search]);

  const handleModalClose = () => {
    setMainTitle("");
    setDescription("");
    setOfferTag("");
    setIds(null);
    setCategoryId("");
    setBrandId("");
    setSubCategoryId("");
    setBannerName("");
    setRowData({});
    handleClose1();
  };

  const brandDataList = () => {
    axios
      .post(
        `${baseUrl}api/admin/multivendor-show-brand-list/`,
        { store_id: storeId },
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setBrandData(response?.data?.brand_data);
      })
      .catch((error) => {
        console.log("", error);
      });
  };
  useEffect(() => {
    brandDataList();
  }, []);

  const bannerSectionDataList = () => {
    axios
      .post(
        `${baseUrl}api/admin/multivendor-banner-section-list/`,
        {},
        {
          headers: {
            Token: localStorage.getItem("Token"),
          },
        }
      )
      .then((response) => {
        setBannerData(response?.data?.banner_section_list);
      })
      .catch((error) => {
        console.log("", error);
      });
  };
  useEffect(() => {
    bannerSectionDataList();
  }, []);

  const handleChange = (event, value) => {
    setPage(value);
  };

  const DeleteBanner = (id) => {
    const reqbody = {
      banner_id: id,
    };

    axios
      .delete(
        `${baseUrl}api/admin/multivendor-update-banner/`,
        {
          data: reqbody,
          headers: {
            Token: localStorage.getItem("Token"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        toast.success(response.data.message);
        bannerListShow();
      })
      .catch((error) => {
        console.error("Error deleting banner:", error);
        toast.error("Failed to delete banner. Please try again.");
      });
  };

  // var modal = document.getElementById("myModal");
  // var img = document.getElementById("myImg");
  // var modalImg = document.getElementById("img01");
  // var captionText = document.getElementById("caption");
  // img.onclick = function () {
  //   modal.style.display = "block";
  //   modalImg.src = this.src;
  //   modalImg.alt = this.alt;
  //   captionText.innerHTML = this.alt;
  // };
  // modal.onclick = function () {
  //   img01.className += " out";
  //   setTimeout(function () {
  //     modal.style.display = "none";
  //     img01.className = "modal-content";
  //   }, 400);
  // };

  return (
    <div className=" !bg-slate-100">
      <div className="flex justify-between">
        <div className="p-2">
          <p className="text-xl !text-black font font-bold">
            Banner Management List
          </p>
        </div>
        <div className="p-2 pt-5"></div>
      </div>
      <div className="flex flex-col !rounded !text-black bg-slate-100 shadow-card shadow-zinc-600 m-2">
        <div className="flex items-center justify-between my-2">
          <span className="flex  gap-3">
            <input
              type="text"
              className="!border-3 !border-black mx-3 !w-72 px-2 rounded-md py-1"
              placeholder="search"
              style={{ border: "1px solid black" }}
              onChange={(e) => setSearch(e.target.value)}
            />
          </span>
          <span>
            <div className="text-red-500 mx-3">
              <Button variant="outlined" color="primary" onClick={handleOpen1}>
                <AddIcon />
                Add Banner
              </Button>
              <Modal
                open={open1}
                onClose={handleClose1}
                aria-labelledby="child-modal-title"
                aria-describedby="child-modal-description"
              >
                <Box
                  sx={{ ...style, width: 830 }}
                  className="rounded-2xl !border-0"
                >
                  <div
                    id="child-modal-title "
                    className="!text-black !underline !font-bold !py-3 !text-center !text-xl"
                  >
                    {ids === null ? "Add Banner" : "Update Banner"}
                  </div>
                  <div className="flex justify-between w-full">
                    <div className="w-[48%]">
                      <div>Select Category</div>
                      <FormControl fullWidth>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          className="mt-1"
                          name="main_category_id"
                          value={categoryId || rowData?.category?.id || ""}
                          onChange={(event) =>
                            setCategoryId(event.target.value)
                          }
                        >
                          {categoryData?.map((elem) => (
                            <MenuItem value={elem?.id}>
                              {elem?.category}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <div className="mt-2">Select Brand</div>
                      <FormControl fullWidth>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          className="mt-1"
                          name="brand_name_id"
                          value={brandId || rowData?.brand?.id || ""}
                          onChange={(event) => setBrandId(event.target.value)}
                        >
                          {brandData?.map((elem) => (
                            <MenuItem value={elem?.id}>
                              {elem?.brand_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <div className="mt-2">Title</div>
                      <TextField
                        size="small"
                        id="outlined-basic"
                        value={mainTitle}
                        onChange={(event) => setMainTitle(event.target.value)}
                        className="!w-[100%] !mt-1"
                        name="product_name"
                      />
                      <div className="mt-2">Description </div>
                      <TextField
                        size="small"
                        id="outlined-basic"
                        className="!w-[100%] !mt-1"
                        name="description"
                        value={description}
                        onChange={(event) => setDescription(event.target.value)}
                      />
                    </div>
                    <div className="w-[48%]">
                      <div>Select Sub Category</div>
                      <FormControl fullWidth>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          name="sub_category_id"
                          className="mt-1"
                          value={
                            subCategoryId || ""
                          }
                          onChange={(event) =>
                            setSubCategoryId(event.target.value)
                          }
                        >
                          {subCategoryData?.map((elem) => (
                            <MenuItem value={elem?.id}>
                              {elem?.subcategory}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                      <div className="mt-2"> Select Banner Section</div>
                      <FormControl fullWidth>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          size="small"
                          className="mt-1"
                          value={bannerName || rowData?.banner_section || ""}
                          onChange={(event) =>
                            setBannerName(event.target.value)
                          }
                          name="sub_category_id"
                        >
                          {bannerData?.map((elem) => (
                            <MenuItem value={elem?.value}>
                              {elem?.value}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>

                      <div className="mt-2">Offer Tag </div>
                      <TextField
                        size="small"
                        id="outlined-basic"
                        className="!w-[100%] !mt-1"
                        name="product_name"
                        value={offerTag}
                        onChange={(event) => setOfferTag(event.target.value)}
                      />

                      <div className="mt-2">Image</div>
                      <TextField
                        size="small"
                        type="file"
                        onChange={(event) => setImage(event.target.files[0])}
                        id="outlined-basic"
                        className="!w-[100%] !mt-1"
                        name="product_name"
                      />

                      <div className="mt-2">Link </div>
                      <TextField
                        size="small"
                        id="outlined-basic"
                        className="!w-[100%] !mt-1"
                        name="manual_link"
                        value={manual_link}
                        onChange={(event) => setManualLink(event.target.value)}
                      />
                    </div>
                  </div>
                  <Button
                    onClick={handleModalClose}
                    variant="contained"
                    color="warning"
                    className="!py-2 !mt-3"
                  >
                    CANCEL
                  </Button>
                  <Button
                    variant="contained"
                    type="submit"
                    color="success"
                    className="!py-2 !px-5 !font-bold !mt-3 !float-right"
                    onClick={submitCategory}
                  >
                    {ids === null ? "ADD" : "UPDATE"}
                  </Button>
                </Box>
              </Modal>
            </div>
          </span>
        </div>
        <TableContainer
          component={Paper}
          sx={{ width: "100%", maxHeight: "71vh" }}
          className="!text-black !mx-auto !bg-white overflow-auto px-2"
        >
          <Table stickyHeader aria-label="sticky table" size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  ID
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  CATEGORY
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  MAIN TITLE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  Banner SECTION
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  IMAGE
                </TableCell>
                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  OFFER TAG
                </TableCell>


                <TableCell
                  style={{
                    borderRight: "1px solid #D0D0D0",
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  Link
                </TableCell>
                <TableCell
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  EDIT
                </TableCell>

                <TableCell
                  style={{
                    fontFamily: "'Poppins', sans-serif",
                  }}
                  className="!text-center !text-gray-800 !font-bold"
                >
                  DELETE
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody className="!bg-red">
              {data &&
                data?.map((row, index) => (
                  <TableRow key={row.id} className="!text-slate-700">
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row.id ? row.id : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.category?.category ? row?.category?.category : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.main_title ? row?.main_title : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.banner_section ? row?.banner_section : "--"}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row?.image ? (
                        <img
                          src={row?.image}
                          alt="No"
                          className="h-8 mx-auto w-8"
                        />
                      ) : (
                        // <>
                        //   <section>
                        //     <div class="rt-container">
                        //       <div class="col-rt-12">
                        //         <div class="Scriptcontent">
                        //           <img
                        //             id="myImg"
                        //             src={row?.image}
                        //             alt="No"
                        //             width="30"
                        //             height="30"
                        //           />
                        //           <div id="myModal" class="modal">
                        //             <img class="modal-content" id="img01" />
                        //           </div>
                        //         </div>
                        //       </div>
                        //     </div>
                        //   </section>
                        // </>
                        "--"
                      )}
                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      {row.offer_tag ? row.offer_tag : "--"}
                    </TableCell>



                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        borderRight: "1px solid #D0D0D0",
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >

                      {row.manual_link && row.manual_link !== "/" ? (
                        <a href={row.manual_link} className="text-blue-500 text-xs" target="_blank" rel="noopener noreferrer">
                          {row.manual_link}
                        </a>
                      ) : (
                        <span>--</span>
                      )}



                    </TableCell>
                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <div onClick={handleOpen1}>
                        <BorderColorIcon
                          className="text-green-400"
                          onClick={() => editFunctionality(row)}
                        />
                      </div>
                    </TableCell>

                    <TableCell
                      className="!text-center !text-[12px]"
                      style={{
                        fontFamily: "'Poppins', sans-serif",
                      }}
                    >
                      <Delete
                        className="text-red-600"
                        onClick={() => DeleteBanner(row?.id)}
                      />
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          {data.length > 0 ? (
            <div className="flex justify-center p-2">
              <Pagination
                page={currentPage}
                size="small"
                count={totalPage}
                variant="outlined"
                color="primary"
                onChange={handleChange}
              />
            </div>
          ) : (
            <div class="spinner"></div>
          )}
        </TableContainer>
      </div>
    </div>
  );
};

export default Slider;
